import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ commissions }) => {
    const rows = commissions.map(commission => <TableRow key={commission.id} {...commission} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/TableBody.js